export var MAX_COUNT_TO_RENDER = 1;
export var MAX_EXPIRY_DATE_TIME_STAMP = '9999-12-31';
//# sourceMappingURL=couponPeekConsts.js.map